<div class="layout-wrapper" [ngClass]="containerClass">
  <globot-topbar></globot-topbar>
  <globot-sidebar></globot-sidebar>
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<globot-acquisition-source-modal
  [visible]="showAcquisitionModal"
  (closed)="showAcquisitionModal = false"
></globot-acquisition-source-modal>
